var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "prop-types", "classnames", "../Icon/ArteVertical"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("prop-types"), require("classnames"), require("../Icon/ArteVertical"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.ArteVertical);
    global.Modal = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _propTypes, _classnames, _ArteVertical) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _react = _interopRequireDefault(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _classnames = _interopRequireDefault(_classnames);
  _ArteVertical = _interopRequireDefault(_ArteVertical);

  var Modal = function Modal(_ref) {
    var buttons = _ref.buttons,
        html = _ref.html,
        message = _ref.message,
        onModalClose = _ref.onModalClose,
        open = _ref.open,
        title = _ref.title;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('next-modal', {
        show: open
      }),
      onClick: onModalClose
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "next-modal__main",
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "next-modal__logo"
    }, /*#__PURE__*/_react.default.createElement(_ArteVertical.default, {
      size: "xsmall"
    })), /*#__PURE__*/_react.default.createElement("div", null, title && /*#__PURE__*/_react.default.createElement("h3", {
      className: "next-modal__title"
    }, title), message && /*#__PURE__*/_react.default.createElement("div", {
      className: "next-modal__message"
    }, message), html && /*#__PURE__*/_react.default.createElement("div", {
      className: "next-modal__html",
      dangerouslySetInnerHTML: {
        __html: html
      }
    }), buttons && /*#__PURE__*/_react.default.createElement("div", {
      className: "next-modal__buttons"
    }, buttons))));
  };

  Modal.propTypes = {
    buttons: _propTypes.default.arrayOf(_propTypes.default.node),
    html: _propTypes.default.string,
    message: _propTypes.default.string,
    open: _propTypes.default.bool,
    onModalClose: _propTypes.default.func,
    title: _propTypes.default.string
  };
  Modal.defaultProps = {
    open: false
  };
  var _default = Modal;
  _exports.default = _default;
});